import { Component, Host, Inject, OnInit, Optional } from '@angular/core';
import { BaseColumnControlValidatorPlugin } from '@controls/core/base-column-validator-plugin.service';
import { InputControlBuilder } from '@controls/core/input-control-builder.service';
import { ControlListenerPlugin, ControlListenerPluginToken } from '@controls/model/control-listener-plugin';
import { ControlValidatorPlugin, ControlValidatorPluginToken } from '@controls/model/control-validator-plugin';
import { FormControlMaker, FormControlMakerToken } from '@controls/model/form-control-maker';
import { ColumnErrorMessengerListenerService } from '@records/controls/common/listeners/column-error-messenger.service';
import { InputContainerComponent } from '@records/controls/input-container/plugins/input-container/input-container.component';
import { Column } from 'exceljs';
import { getLovValueKey } from '@shared/utils/helpers/lov-datakey-factory';
import { SelectItem } from 'primeng/api';
import { UntypedFormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { InputPropOption } from '../filters-bar/input-props';

@Component({
  selector: 'miq-select-with-search',
  templateUrl: './select-with-search.component.html',
  providers: [
    { provide: FormControlMakerToken, useExisting: InputControlBuilder },
    { provide: ControlValidatorPluginToken, useExisting: BaseColumnControlValidatorPlugin },
    {
      provide: ControlListenerPluginToken,
      useExisting: ColumnErrorMessengerListenerService,
    },
  ],
  styleUrls: ['./select-with-search.component.scss'],
  standalone: false,
})
export class SelectWithSearchComponent extends InputContainerComponent implements OnInit {
  dropdownOptions: any = [];
  public optionsFilterControl: UntypedFormControl = new UntypedFormControl();
  filteredOptions: ReplaySubject<InputPropOption[]> = new ReplaySubject<InputPropOption[]>(1);

  constructor(
    // control builder
    @Inject(FormControlMakerToken) controlBuilder: FormControlMaker,
    // validator
    @Host() @Inject(ControlValidatorPluginToken) controlValidatorPlugin: ControlValidatorPlugin<Column>,
    // optional services
    // listeners
    @Host()
    @Optional()
    @Inject(ControlListenerPluginToken)
    listenerPlugins: Array<ControlListenerPlugin<Column>>
  ) {
    super(controlBuilder, controlValidatorPlugin, listenerPlugins);
  }
  filteredList5 = [];
  ngOnInit(): void {
    super.ngOnInit();
    const dataKey = getLovValueKey(this.config);
    //This function will get key,value pairs from main  object and gives array having key and value pairs
    this.dropdownOptions = this.config.values
      .filter(key => !!key[dataKey])
      .map(key => ({ ...key, value: key.value }))
      .map(
        val =>
          ({
            value: val.value,
            key: val[dataKey],
            disabled: val.disabled,
          }) as any as SelectItem
      );
    this.filteredOptions.next(this.dropdownOptions.slice());
    this.optionsFilterControl.valueChanges.pipe().subscribe(value => {
      this.filterOptions(value);
    });
  }
  /**
   * Filters out the select options depending on a string input and assigns them to
   * the {@see filteredOptions} ReplaySubject.
   */
  private filterOptions(filterValue: string): void {
    if (!this.dropdownOptions) {
      return;
    }
    if (!filterValue) {
      this.filteredOptions.next(this.dropdownOptions.slice());
      return;
    }
    this.filteredOptions.next(
      this.dropdownOptions.filter(
        option => (option.value || option.key).toLowerCase().indexOf(filterValue.toLowerCase()) > -1
      )
    );
  }

  /**
   * Clear the search text
   */
  clearSearchBox() {
    this.optionsFilterControl.setValue('');
  }

  /**
   * When the Select Closes clear the Search Control
   * @param _evt
   */
  openedChange(evt: Boolean) {
    if (!evt) {
      this.clearSearchBox();
    }
  }
}
